import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Attach fallback Authorization header from localStorage (for cross-domain if cookies get blocked)
api.interceptors.request.use((config) => {
    const t = localStorage.getItem("flatch_token");
    if (t && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export function saveToken(token) {
    if (token) localStorage.setItem("flatch_token", token);
}
export function clearToken() {
    localStorage.removeItem("flatch_token");
}

export function photoUrl(photoId) {
    const t = localStorage.getItem("flatch_token") || "";
    return `${API_BASE}/photos/${photoId}${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
}

export function formatDetail(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Something went wrong";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return String(d);
}
